(() => {
  if (window.cbSizeOptionsReady) return;
  window.cbSizeOptionsReady = true;
  const initialized = new WeakSet();
  const sorted = new WeakSet();
  const area = (value) => {
    const match = value.toLowerCase().replaceAll(',', '.').match(/(\d+(?:\.\d+)?)\s*[x×]\s*(\d+(?:\.\d+)?)/);
    if (match) return Number(match[1]) * Number(match[2]);
    const count = value.trim().replaceAll(',', '.').match(/^(\d+(?:\.\d+)?)(?:\s*(?:unidades?|u\.?|páginas?|paginas?))?$/i);
    return count ? Number(count[1]) : null;
  };
  const enhance = () => {
    document.querySelectorAll('product-info').forEach((info) => {
      const picker = info.querySelector('variant-selects');
      if (!picker) return;
      const groups = Array.from(picker.querySelectorAll('[data-cb-size-options]'));
      groups.forEach((group) => {
        if (sorted.has(group)) return;
        sorted.add(group);
        const inputs = Array.from(group.querySelectorAll('input[type="radio"]'));
        if (!inputs.length || inputs.some((input) => area(input.value) === null)) return;
        inputs.sort((a, b) => area(a.value) - area(b.value));
        const fragment = document.createDocumentFragment();
        inputs.forEach((input) => {
          const label = group.querySelector(`label[for="${CSS.escape(input.id)}"]`);
          fragment.append(input);
          if (label) fragment.append(label);
        });
        group.append(fragment);
      });
      if (initialized.has(info) || groups.length !== 1) return;
      initialized.add(info);
      const url = new URL(window.location.href);
      if (url.searchParams.has('variant') || url.searchParams.has('option_values') || picker.dataset.cbExplicitVariant === 'true') return;
      const inputs = Array.from(groups[0].querySelectorAll('input[type="radio"]'));
      if (!inputs.length || inputs.some((input) => area(input.value) === null)) return;
      const largest = inputs.filter((input) => !input.disabled && !input.classList.contains('disabled')).at(-1);
      if (!largest) return;
      if (!largest.checked) {
        largest.checked = true;
        largest.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });
  };
  Promise.all([customElements.whenDefined('product-info'), customElements.whenDefined('variant-selects')]).then(() => {
    enhance();
    new MutationObserver(enhance).observe(document.body, { childList: true, subtree: true });
    document.addEventListener('shopify:section:load', enhance);
  });
})();
